export default __webpack_public_path__ + "agent_bg3_me12859.png";